import React, { FormEvent, useEffect, useRef, useState } from "react";
import { SearchIcon, XIcon } from "lucide-react";
type SearchFormProps = {
  initialQuery?: string;
  onSearch: (query: string) => void;
  autoFocus?: boolean;
  size?: "compact" | "large";
  onCancel?: () => void;
};
export function SearchForm({
  initialQuery = "",
  onSearch,
  autoFocus = false,
  size = "large",
  onCancel
}: SearchFormProps) {
  const [query, setQuery] = useState(initialQuery);
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    setQuery(initialQuery);
  }, [initialQuery]);
  useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus();
    }
  }, [autoFocus]);
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = query.trim();
    if (trimmed) {
      onSearch(trimmed);
    }
  };
  const isCompact = size === "compact";
  return <form role="search" onSubmit={handleSubmit} className={`flex items-center border border-[#ff3aa2]/60 bg-[#220d20] focus-within:border-[#35dceb] ${isCompact ? "h-8" : "h-12"}`} data-id="element-286" data-mp="mukc17h5laza">
      <SearchIcon size={isCompact ? 14 : 18} className={`shrink-0 text-[#35dceb] ${isCompact ? "ml-2" : "ml-4"}`} aria-hidden="true" data-id="element-287" data-mp="3eh0vig70g741" />
      <label htmlFor={isCompact ? "header-search" : "page-search"} className="sr-only" data-id="element-288" data-mp="3j90qdu8849tr">
        Search products
      </label>
      <input ref={inputRef} id={isCompact ? "header-search" : "page-search"} type="search" value={query} onChange={event => setQuery(event.target.value)} onKeyDown={event => {
      if (event.key === "Escape" && onCancel) {
        onCancel();
      }
    }} placeholder="Search tumblers, rhinestones, pens…" className={`min-w-0 flex-1 bg-transparent text-white placeholder:text-white/40 focus:outline-none ${isCompact ? "px-2 text-xs normal-case tracking-normal" : "px-3 text-base"}`} data-id="element-289" data-mp="3o6alnqianfpi" />
      {onCancel ? <button type="button" onClick={onCancel} aria-label="Close search" className="mr-1 inline-flex h-6 w-6 items-center justify-center text-white/60 transition-colors duration-150 ease-out hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#35dceb]" data-id="element-290" data-mp="koiqk38v2fn3">
          <XIcon size={14} aria-hidden="true" data-id="element-291" data-mp="4zvt1gn2oayq" />
        </button> : <button type="submit" className="mr-1.5 h-9 bg-[#35dceb] px-4 text-sm font-semibold text-[#10070f] transition-colors duration-150 ease-out hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" data-id="element-292" data-mp="2cfkiy7827u">
          Search
        </button>}
    </form>;
}